import { render, staticRenderFns } from "./PowerFutures.vue?vue&type=template&id=31cbb364"
import script from "./PowerFutures.vue?vue&type=script&lang=js"
export * from "./PowerFutures.vue?vue&type=script&lang=js"
import style0 from "./PowerFutures.vue?vue&type=style&index=0&id=31cbb364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports